<template lang="pug">
.sv-radio
    label.sv-radio__label(
        @mouseover="hovered(true)"
        @mouseleave="hovered(false)"
    )
        input.sv-radio__input(
            type="radio"
            :checked="isChecked"
            @change="changeVal"
        )

        SvIcon.sv-radio__icon(
            :icon="checkIcon"
            :width="20"
            :height="20"
        )

        .sv-radio__content
            slot
                | {{ label }}
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'Svradio',

  model: {
    prop: 'checked',
    event: 'input',
  },

  props: {
    checked: {
      type: [Array, String, Boolean],
      default: false,
    },

    value: {
      type: [String, Boolean],
      default: true,
    },

    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    checkIcon() {
      if (this.isChecked) {
        return 'radio-check';
      }
      return this.isHovered ? 'radio-hover' : 'radio-unchecked';
    },

    isChecked() {
      if (Array.isArray(this.checked)) {
        return !!this.checked.find(v => v === this.value);
      }
      return this.value === this.checked;
    },
  },

  methods: {
    hovered(val) {
      this.isHovered = val;
    },

    changeVal() {
      this.$emit('input', this.value);
    },
  },

  components: {
    SvIcon,
  },
};
</script>

<style lang="scss" scoped>
.sv-radio {
    &__label {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    &__content {
        padding-left: 10px;
        line-height: 100%;
    }

    &__input {
        width: 20px;
        height: 20px;
        z-index: -1;
        opacity: 0;
        position: absolute;
    }
}
</style>
